import Vue from 'vue';
import Password from 'primevue/password';

Vue.component('Password', Password);
